import { useTranslation } from "react-i18next";
import { CollapsibleSection } from "components/designV2/collapsibleSection/collapsibleSection";
import { type CompanyGigApplications } from "model/Gig";
import {
  ApplicationsCountBadge,
  ApplicationsList,
} from "./teamPublicDetailsModal.styled";
import { TeamPublicDetailsModalApplicationRow } from "./teamPublicDetailsModal.applicationRow.component";
import type { TeamPublicApplicationAction } from "./teamPublicDetailsModal.contract";
import { getApplicationWorkerExternalId } from "./teamPublicDetailsModal.mapper";
import { DetailsMessage } from "../shiftDetailsModal.styled";

interface TeamPublicDetailsModalApplicationsSectionProps {
  readonly canManageApplications: boolean;
  readonly applications: ReadonlyArray<CompanyGigApplications>;
  readonly activeApplicationId: number | null;
  readonly avatarUrls: Record<string, string>;
  readonly isPublicShift: boolean;
  readonly onOpenMotivationalLetterModal: (motivationalLetter: string) => void;
  readonly onOpenApplicationActionConfirm: (
    action: TeamPublicApplicationAction,
  ) => void;
}

export const TeamPublicDetailsModalApplicationsSection: React.FC<
  TeamPublicDetailsModalApplicationsSectionProps
> = (props) => {
  const { t } = useTranslation();
  const hasApplications = props.applications.length > 0;

  return (
    <CollapsibleSection
      label={t("Schedule.TeamPublicApplications")}
      defaultOpen={hasApplications}
      headerRight={
        hasApplications ? (
          <ApplicationsCountBadge>
            {props.applications.length}
          </ApplicationsCountBadge>
        ) : undefined
      }
    >
      {!hasApplications ? (
        <DetailsMessage>
          {t("ApplicationsCompany.NoApplications")}
        </DetailsMessage>
      ) : (
        <ApplicationsList>
          {props.applications.map((application) => {
            const sharedProps = {
              application,
              avatarUrl:
                props.avatarUrls[getApplicationWorkerExternalId(application)],
              isPublicShift: props.isPublicShift,
              isBusy: props.activeApplicationId === application.id,
              onOpenMotivationalLetterModal:
                props.onOpenMotivationalLetterModal,
            };

            return (
              <TeamPublicDetailsModalApplicationRow
                key={application.id}
                {...sharedProps}
                canManageApplication
                readOnly={!props.canManageApplications}
                onOpenApplicationActionConfirm={
                  props.onOpenApplicationActionConfirm
                }
              />
            );
          })}
        </ApplicationsList>
      )}
    </CollapsibleSection>
  );
};
